import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import {DNA} from '@dna/react';
import {GroupedResidentPharmacyMedications, SelectableMedication} from './usePharmacyMedications';
import {
    Box,
    Card,
    CardContent,
    ListSubheader
} from '@material-ui/core';
import {CollapsedPharmacyMedicationCard} from './pharmacy-medication-card/PharmacyMedicationCard';
import {RenderIf} from "../common/render-if/RenderIf";
import clsx from 'clsx';

const useStyles = makeStyles({
        root: {
            width: '100%',
            //maxWidth: 360,
            backgroundColor: DNA.tokens.color.gray[100],
            "& .confirm": {
                paddingLeft: 11
            }
        },
        cardRoot: {
            width: "100%"
        },
        selectedCard: {
            backgroundColor: "#ebf3fb"
        },
        cardContent: {
            padding: "0 !important"
        },
        cardHeader:{
            color:"#414141",
            fontWeight:600,
            fontSize:"12px",
            lineHeight:"16px",
            letterSpacing:"0.2em",
            padding: "12px 16px 12px 16px"
        },
        countMed:{
            color:"#006AD2"
        }
    }
);

export const PharmacyMedicationsCollapsed = (props: {
    medications: SelectableMedication[];
    isSelected: (item: SelectableMedication) => boolean;
    onMedicationActioned: (authoringSystem: string, authoringSystemForeignKey: string) => void;
    confirmActionButton: JSX.Element;
    onRowSelected?: (authoringSystem: string, authoringSystemForeignKey: string, encounterAuthoringSystem: string, encounterAuthoringSystemForeignKey: string) => void;
    onStartEditingDosageTimes?:(authoringSystem: string, authoringSystemForeignKey: string) => void;
}) => {
    const classes = useStyles();
    let groupedData = new GroupedResidentPharmacyMedications(props.medications)
    
    const getListItem = (m: SelectableMedication) => {
        let isSelected = props.isSelected(m);

        return <ListItem key={m.id} button>
            <Card className={clsx({
                [classes.selectedCard]: isSelected,
            }, classes.cardRoot)} variant="outlined"
                  onClick={rowEvent => {
                      let nodeName = (rowEvent.target as any).nodeName;
                      if (nodeName === 'INPUT') {
                          return;
                      }
                      rowEvent.stopPropagation();
                      if (props.onRowSelected) {
                          let {
                              authoringSystem,
                              authoringSystemForeignKey,
                              encounterAuthoringSystem,
                              encounterAuthoringSystemForeignKey
                          } = m;
                          props.onRowSelected(authoringSystem, authoringSystemForeignKey, encounterAuthoringSystem, encounterAuthoringSystemForeignKey);
                      }
                  }}
            >
                <CardContent className={classes.cardContent}>
                    <CollapsedPharmacyMedicationCard
                        isSelected={isSelected}
                        item={m}
                        onActioned={props.onMedicationActioned}
                        onDosageClicked={(authoringSystem,authoringSystemForeignKey) => {
                            if (props.onStartEditingDosageTimes){
                                props.onStartEditingDosageTimes(authoringSystem,authoringSystemForeignKey);   
                            }
                        }}
                    />
                </CardContent>

            </Card>
        </ListItem>;
    };
    return (
            <Box className={classes.root}>
                <RenderIf if={groupedData.regular?.count > 0}>
                    <List aria-label="Medications list" subheader={
                        <ListSubheader className={classes.cardHeader} component="div" id={"regular"}>
                            regular (<span className={classes.countMed}>{groupedData.regular?.count}</span>)
                        </ListSubheader>
                    }>
                        {groupedData.regular.data.map(getListItem)}

                    </List>
                </RenderIf>
                <RenderIf if={groupedData.shortCourse?.count > 0}>
                    <List aria-label="Medications list" subheader={
                        <ListSubheader className={classes.cardHeader} component="div" id={"shortCourse"}>
                            short course (<span className={classes.countMed}>{groupedData.shortCourse?.count}</span>)
                        </ListSubheader>
                    }>
                        {groupedData.shortCourse.data.map(getListItem)}

                    </List>
                </RenderIf>
                <RenderIf if={groupedData.prn?.count > 0}>
                    <List aria-label="Medications list" subheader={
                        <ListSubheader className={classes.cardHeader} component="div" id={"prn"}>
                            prn (<span className={classes.countMed}>{groupedData.prn?.count}</span>)
                        </ListSubheader>
                    }>
                        {groupedData.prn.data.map(getListItem)}

                    </List>
                </RenderIf>
                <RenderIf if={groupedData.ceasedConfirmed?.count > 0}>
                    <List aria-label="Medications list" subheader={
                        <ListSubheader className={classes.cardHeader} component="div" id={"ceasedConfirmed"}>
                            Ceased medication (<span className={classes.countMed}>{groupedData.ceasedConfirmed?.count}</span>)
                        </ListSubheader>
                    }>
                        {groupedData.ceasedConfirmed.data.map(getListItem)}

                    </List>
                </RenderIf>
                <List>
                    <ListItem>
                        {props.confirmActionButton}
                    </ListItem>
                </List>

            </Box>
        
    );
}